import { render } from "./TheFooter.vue?vue&type=template&id=6bcb0566"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=6bcb0566&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__